import { render, staticRenderFns } from "./UpmsUserSettings.vue?vue&type=template&id=45be4742&"
import script from "./UpmsUserSettings.vue?vue&type=script&lang=js&"
export * from "./UpmsUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UpmsUserSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports